import API from "./api";
import { setStoredAccessToken } from "../utils/authSession";

export async function fetchLoginOptions() {
  const { data } = await API.get("/auth/login-options");
  return data;
}

export async function loginWithGoogleCredential(credential) {
  const { data } = await API.post("/auth/google/token", { credential });
  if (data?.access_token) setStoredAccessToken(data.access_token);
  return data;
}

export async function login({ mode, identifier, password, organisation_id }) {
  if (!mode || !identifier || !password) {
    throw new Error("Missing login credentials.");
  }

  if (mode === "admin") {
    const raw = String(identifier).trim();
    const isEmail = raw.includes("@");
    if (!isEmail && !/^[A-Za-z0-9_]+$/.test(raw)) {
      throw new Error("Use your username (letters, numbers, underscore) or work email.");
    }

    const form = new URLSearchParams();
    form.append("username", raw);
    form.append("password", password);

    const { data } = await API.post("/auth/login", form, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
    if (data?.access_token) setStoredAccessToken(data.access_token);
    return data;
  }

  if (mode === "employee") {
    const email = String(identifier).trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      throw new Error("Enter a valid email address.");
    }
    const { data } = await API.post("/employee-auth/login", {
      email,
      password,
      organisation_id: organisation_id || null,
    });
    if (data?.access_token) setStoredAccessToken(data.access_token);
    return data;
  }

  throw new Error("Invalid login mode.");
}

